import ecRecommendationTypes from '../experienceScore/ecRecommendationTypes';
import insightsAndTipsCodes from '../experienceScore/insightsAndTipsCodes';
import pushNotificationSystemSubTypes from './pushNotificationSystemSubTypes';

const ecPushRecommendationTypes = {
    [pushNotificationSystemSubTypes.EXP_COACH_PUFF_TIME_FAST]: insightsAndTipsCodes.EG002,
    [pushNotificationSystemSubTypes.EXP_COACH_STICK_REUSED_DETECTED]: insightsAndTipsCodes.EG004,
    [pushNotificationSystemSubTypes.EXP_COACH_SHORT_SESSION_DETECTED]: ecRecommendationTypes.SHORT_SESSION,
    [pushNotificationSystemSubTypes.EXP_COACH_FREQUENT_LIMITATION_DETECTED]: ecRecommendationTypes.FREQUENT_LIMITATION,
    [pushNotificationSystemSubTypes.EXP_COACH_DEVICE_OVERHEATING_DETECTED]: ecRecommendationTypes.DEVICE_OVERHEATING,
};

export default ecPushRecommendationTypes;
